import { useEffect, useState } from "react";

/** Дебаунс значения: обновляется только после `delay` мс без изменений.
 *  Использовать для поисковых полей — иначе каждый символ = запрос. */
export function useDebouncedValue<T>(value: T, delay = 350): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(t);
  }, [value, delay]);
  return debounced;
}
